var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "whatsapp-comparison" }, [
    _c("div", { staticClass: "comparison-header" }, [
      _c("h2", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.whatsappSolutionsComparison"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-container" },
        [
          _c("a-input-search", {
            staticStyle: { "max-width": "300px" },
            attrs: { placeholder: _vm.$t("message.searchFeaturePlaceholder") },
            on: { input: _vm.filterFeatures },
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-wrapper" }, [
      _c("div", { staticClass: "table-header-fixed" }, [
        _c("table", { staticClass: "comparison-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "feature-column" }, [
                _vm._v(_vm._s(_vm.$t("message.feature"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "solution-column" }, [
                _c("div", { staticClass: "solution-header" }, [
                  _c(
                    "div",
                    { staticClass: "img whatsapp" },
                    [
                      _c("WhatsappV3Icon", {
                        staticStyle: { width: "24px", height: "24px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "solution-info" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.whatsappV3")))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "solution-subtitle" }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.qrCodeUnofficialSolution"))
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "solution-column" }, [
                _c("div", { staticClass: "solution-header" }, [
                  _c(
                    "div",
                    { staticClass: "img whatsapp" },
                    [
                      _c("WhatsappBusinessIcon", {
                        staticStyle: { width: "24px", height: "24px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "solution-info" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.whatsappWaba"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "solution-subtitle" }, [
                      _vm._v(_vm._s(_vm.$t("message.metaOfficialApiSolution"))),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "solution-column" }, [
                _c("div", { staticClass: "solution-header" }, [
                  _c(
                    "div",
                    { staticClass: "img whatsapp-coex" },
                    [
                      _c("WhatsappBusinessIcon", {
                        staticStyle: { width: "24px", height: "24px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "solution-info" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.wabaCoex")))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "solution-subtitle" }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.supsisProviderCoexistence"))
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-body-scrollable" }, [
        _c("table", { staticClass: "comparison-table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.filteredCategories, function (category) {
                return [
                  _c(
                    "tr",
                    {
                      key: "header-" + category.name,
                      staticClass: "category-header",
                    },
                    [
                      _c("td", { attrs: { colspan: "4" } }, [
                        _c("div", { staticClass: "category-title" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(category.icon)),
                          ]),
                          _vm._v(
                            "\n                                    " +
                              _vm._s(category.name) +
                              "\n                                "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(category.features, function (feature) {
                    return _c(
                      "tr",
                      {
                        key: category.name + "-" + feature.name,
                        staticClass: "feature-row",
                      },
                      [
                        _c(
                          "td",
                          { staticClass: "feature-name" },
                          [
                            _c("span", [_vm._v(_vm._s(feature.name))]),
                            _vm._v(" "),
                            feature.description
                              ? _c(
                                  "a-tooltip",
                                  { attrs: { title: feature.description } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "material-icons info-icon",
                                      },
                                      [_vm._v("info")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "support-cell" }, [
                          _c(
                            "div",
                            {
                              staticClass: "support-status",
                              class: _vm.getSupportClass(feature.v3),
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons support-icon" },
                                [_vm._v(_vm._s(_vm.getSupportIcon(feature.v3)))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          feature.v3_note
                            ? _c("div", { staticClass: "support-note" }, [
                                _vm._v(_vm._s(feature.v3_note)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "support-cell" }, [
                          _c(
                            "div",
                            {
                              staticClass: "support-status",
                              class: _vm.getSupportClass(feature.waba),
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons support-icon" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getSupportIcon(feature.waba))
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          feature.waba_note
                            ? _c("div", { staticClass: "support-note" }, [
                                _vm._v(_vm._s(feature.waba_note)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "support-cell" }, [
                          _c(
                            "div",
                            {
                              staticClass: "support-status",
                              class: _vm.getSupportClass(feature.coex),
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons support-icon" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getSupportIcon(feature.coex))
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          feature.coex_note
                            ? _c("div", { staticClass: "support-note" }, [
                                _vm._v(_vm._s(feature.coex_note)),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticClass: "feature-column-width" }),
      _vm._v(" "),
      _c("col", { staticClass: "solution-column-width" }),
      _vm._v(" "),
      _c("col", { staticClass: "solution-column-width" }),
      _vm._v(" "),
      _c("col", { staticClass: "solution-column-width" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "comparison-legend" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "material-icons supported" }, [
          _vm._v("check_circle"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Destekleniyor")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "material-icons partial" }, [_vm._v("help")]),
        _vm._v(" "),
        _c("span", [_vm._v("Kısmi Destek")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "material-icons not-supported" }, [
          _vm._v("cancel"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Desteklenmiyor")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }